import { takeEvery, fork, put, all, call } from "redux-saga/effects"

// Login Redux States
import { CHANGE_PASSWORD } from "./actionTypes"
import {

  putChangePwdSuccess,
  putChangePwdError,
} from "./actions"

//Include Both Helper File with needed methods
import { putChangePassword } from "helpers/backend_helper"

function* changePassword({ payload: { data, callback } }) {
  try {
    const response = yield call(putChangePassword, data)
    if (response.status === "failure") {
      return yield put(putChangePwdError(response.message))
    }

    callback && callback()
    yield put(putChangePwdSuccess(response))
  } catch (error) {
    yield put(putChangePwdError("Internal Server Error"))
  }
}

export function* watchProfile() {
  yield takeEvery(CHANGE_PASSWORD, changePassword)
}

function* ProfileSaga() {
  yield all([fork(watchProfile)])
}

export default ProfileSaga
